<template>
  <div class="flex gap-4">
    <div :class="[{ isComplete: isComplete }, 'mdi mdi-checkbox-marked']"></div>
    <div>{{ label }}</div>
  </div>
</template>
<script>
export default {
  name: 'StatusIndicator',
  props: {
    label: {
      type: String,
      default: undefined,
    },
    isComplete: {
      type: Boolean,
    },
  },
};
</script>
<style scoped lang="scss">

.isComplete {
  color: #14c011;
}
</style>
